'use client';

import { useEffect } from 'react';
import { getCookieValue } from '@/utils/cookies/client';
import { COOKIES } from '@/utils/cookies';
import { LOCAL_STORAGE } from '@/utils/constants';

export const RewardsPageInitializer: React.FC = () => {
    useEffect(() => {
        const userId = getCookieValue(COOKIES.USER_ID);
        const key = `${LOCAL_STORAGE.HAS_SEEN_NEW_REWARDS_PAGE}-${userId}`;

        const checkIfUserHasSeenNewRewardsPage = () => {
            if (!localStorage.getItem(key) && userId) {
                localStorage.setItem(key, 'false');
            }
        };

        checkIfUserHasSeenNewRewardsPage();

        return () => {
            if (localStorage.getItem(key) === 'false' && userId) {
                localStorage.setItem(key, 'true');
            }
        };
    }, []);

    return null;
};
